import {useAsyncWrapper} from "@/composables/useAsyncWrapper";

export default {
  ...useAsyncWrapper('ProductTagViewModule')
}
